module.exports = __webpack_public_path__ + "images/slow-active.ee46318ab1c9c9aa10a121aae436daaa.png";